import { PersonalLoanQuestion } from '@hb/domain/steps/financial-obligation';
import { PersonalLoanStoreService } from '@hb/modules/financial-obligations/personal-loan/personal-loan-store.service';
import { PreviousButtonComponent } from '@hb/modules';
import { PersonalLoanMonthlyPaymentComponent } from '@hb/modules/financial-obligations/personal-loan/personal-loan-monthly-payment/personal-loan-monthly-payment.component';
import { PersonalLoanAmountComponent } from '@hb/modules/financial-obligations/personal-loan/personal-loan-amount/personal-loan-amount.component';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'personal-loan',
    templateUrl: './personal-loan.component.html',
    imports: [PreviousButtonComponent, PersonalLoanMonthlyPaymentComponent, PersonalLoanAmountComponent, ApContentPipe],
    styleUrls: ['../../global/global.scss']
})
export class PersonalLoanComponent implements OnInit, OnDestroy {
    protected readonly store = inject(PersonalLoanStoreService);
    protected activeQuestion: PersonalLoanQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy() {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showPersonalLoanTotalAmount(): boolean {
        return (
            this.activeQuestion === PersonalLoanQuestion.TOTAL_AMOUNT ||
            (this.store.isActiveQuestion(PersonalLoanQuestion.TOTAL_AMOUNT) && this.store.isSummary)
        );
    }
    showPersonalLoanMonthlyAmount(): boolean {
        return (
            this.activeQuestion === PersonalLoanQuestion.MONTHLY_PAYMENT ||
            (this.store.isActiveQuestion(PersonalLoanQuestion.MONTHLY_PAYMENT) && this.store.isSummary)
        );
    }
}
